<template>
    <div class="footer__copyright">
        <span>Copyright © {{ year }} {{ appName }}. All rights reserved.</span>
    </div>
</template>

<script>
export default {
    data() {
        return {
            appName: import.meta.env.VITE_APPNAME,
            year: new Date().getFullYear(),
        };
    },
};
</script>

<style
  lang="scss"
  scoped
>
.footer__copyright {
  font-size: 12px;
}
</style>